import { useState, useEffect } from "react"

import { useGetOptions } from "./useGetOptions"
import { dbDataStore } from "../store/Store"


export const useGetProjectDD = () => {
    // global state 
    const companyData = dbDataStore(dbData => dbData.companyData)
    const rateSheetData = dbDataStore(dbData => dbData.rateSheetData)
    const fuelSurchargeData = dbDataStore(dbData => dbData.fuelSurchargeData)
    const assetRateSheets = dbDataStore(dbData => dbData.assetRateSheets)

    const [dropDowns, setDropDowns] = useState(null) 
    const [companyDD, setCompanyDD] = useState([])
    const [ratesDD, setRatesDD] = useState([])
    const [fscDD, setFscDD] = useState([])
    const [assetRatesDD, setAssetRatesDD] = useState([])
    
    useGetOptions(setCompanyDD, companyData, ...Array(2), 'company_name', null, true)
    useGetOptions(setRatesDD, rateSheetData, ...Array(2), 'rs_name', null, true)
    useGetOptions(setAssetRatesDD, assetRateSheets, ...Array(2), 'rs_name', null, true)
    useGetOptions(setFscDD, fuelSurchargeData, ...Array(2), 'fsc_name', null, true)
    useGetOptions(setAssetRatesDD, assetRateSheets, ...Array(2), 'rs_name', null, true)

    useEffect(() => {
        setDropDowns({
            companies: companyDD,
            rates: ratesDD,
            fsc: fscDD,
            asset_rates: assetRatesDD,
        })
    }, [ratesDD, fscDD, assetRatesDD, companyDD])
    
    return {dropDowns}
}